var r=function(r){for(var a="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",o="",t=0;t<r;t++){var n=Math.floor(62*Math.random());o+=a.charAt(n)}return o};export{r as generateUniqueId};
//# sourceMappingURL=generateUniqueId.js.map
